var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M40.5538 1.51459C41.9265 2.88724 41.9265 5.11275 40.5538 6.4854L18.5634 28.4758C18.397 28.8173 18.1719 29.1374 17.8882 29.4212C16.8745 30.4348 15.3958 30.6999 14.1388 30.2164C13.6189 30.0518 13.1296 29.7634 12.7173 29.3511C12.5222 29.156 12.3548 28.9436 12.2152 28.7189L1.98163 18.4854C0.608985 17.1127 0.608988 14.8872 1.98164 13.5146C3.35428 12.1419 5.57979 12.1419 6.95244 13.5146L15.2677 21.8299L35.583 1.51459C36.9557 0.141945 39.1812 0.141946 40.5538 1.51459Z","fill":"white"}));
}

Check.defaultProps = {"width":"42","height":"31","viewBox":"0 0 42 31","fill":"none"};

module.exports = Check;

Check.default = Check;
